module.exports = __webpack_public_path__ + "static/media/yen-sign.8af57ec5.svg";